var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMegaphone(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "16px",
    viewBox: "0 0 20 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "1_ico/medic") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "v0",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "B1_\\u30C8\\u30C3\\u30D7_\\u30DB\\u30FC\\u30E0\\u8FFD\\u52A0\\u30D0\\u30CA\\u30FC",
    transform: "translate(-16.000000, -83.000000)",
    fill: "#204359"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(16.000000, 81.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.8277947,2.07268844 C15.7202832,1.99116182 15.5846164,1.97724547 15.4666511,2.03584877 L7.00053438,6.24457821 L7,13.7548457 L15.4666511,17.9641937 C15.584583,18.022797 15.7202832,18.0088806 15.8277947,17.9267355 C15.9353061,17.8445904 16,17.7062773 16,17.5570631 L16,2.44294066 C16,2.29376512 15.9363415,2.15421506 15.8277947,2.07268844",
    id: "Fill-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6,7 L1.6464687,7 C0.737362552,7 0.000574633521,7.73919354 0.000574633521,8.65118745 L0,12.3482361 C0,13.2608065 0.737362552,14 1.6464687,14 L6,14 L6,7 Z",
    id: "Fill-4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17,7 L17,13 C18.2886452,13 20.0000252,11.6565009 20.0000252,10.0010288 C20.0000252,8.34342813 18.2886452,7 17,7",
    id: "Fill-6"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMegaphone);
export default __webpack_public_path__ + "static/media/megaphone.2a5d226de16d3ceeff74e7009e5a64d5.svg";
export { ForwardRef as ReactComponent };